// PieChart.jsx
import React, { useEffect, useRef } from "react";
import ApexCharts from "apexcharts";

const PieChart = ({ chartdata, tooltipSuffix = "" }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
      chartInstance.current = null;
    }

    if (!chartdata || !chartdata.categories || !chartdata.series) {
      return;
    }

    const labels = chartdata.categories || [];
    const series = chartdata.series || [];

    if (!labels.length || !series.length) {
      return;
    }

    const chartConfig = {
      series,
      chart: {
        height: 350,
        type: "pie",
        toolbar: { show: true },
      },
      labels,
      legend: {
        position: "bottom",
        horizontalAlign: "center",
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val.toFixed(1) + "%";
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return tooltipSuffix ? `${val} ${tooltipSuffix}` : val;
          },
        },
      },
    };

    chartInstance.current = new ApexCharts(chartRef.current, chartConfig);
    chartInstance.current.render();

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
        chartInstance.current = null;
      }
    };
  }, [chartdata, tooltipSuffix]);

  return (
    <div>
      {!chartdata ? (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <p>No data available</p>
        </div>
      ) : (
        <div ref={chartRef}></div>
      )}
    </div>
  );
};

export default PieChart;
